import { Sky, PointerLockControls } from "@react-three/drei";
import { useThree, useFrame } from '@react-three/fiber';
import { useRef } from "react";
import { OrbitControls  } from "@react-three/drei";
import { KeyboardControls, useKeyboardControls } from "@react-three/drei";
import { Debug, RigidBody, Physics } from "@react-three/rapier";
// import Car from "./game/Car"
// import Car from "./game/Car";
import { extend } from "lodash";
import { Vector3 } from "three";
import Tree from "../components/Tree";
import Car from "../components/Car";



extend({ OrbitControls: OrbitControls })



function getRandomCoords(min, max) {
        const theta = Math.random() * Math.PI * 2;
        const radius = Math.random() * (max - min) + min;
        return new Vector3(radius * Math.cos(theta), 0, radius*Math.sin(theta));
  }

export default function GameScene() {

    // const three = useThree();
    const { camera, gl } = useThree()
    const webcamRef = useRef(null);
    // console.log(camera);
    // console.log(gl);

    const nTrees = 50;
    var Trees = [];
    for (let i = 0; i < nTrees; i++) {
        Trees.push(getRandomCoords(10, 100));
    }
    // console.log(Trees);
    return <>
        <OrbitControls args={ [ camera, gl.domElement] } />
        <Sky sunPosition={[100, 20, 100]} />
        <ambientLight intensity={0.3} />
        <directionalLight position={ [1, 1, 0.1] } intensity={ 0.5 } castShadow={ true }/>
        <pointLight castShadow intensity={0.8} position={[100, 100, 100]} />
        
        
        {/* <Physics interpolate={true} timestep="vary"> */}
        <Physics>
        {/* <Debug /> */}
            <RigidBody type="fixed" friction={ 1 } restitution = { 0 }>
                <mesh position-y={ -1 }rotation-x={ - Math.PI * 0.5 } scale={ 1 }>
                    <boxGeometry args={ [300, 300, 1] }/>
                    <meshStandardMaterial color="orange" />
                </mesh>
            </RigidBody>
            {/* <Tree position={ new Vector3(4, 0, 1) }/> */}
            
            {Trees.map((item,index)=>{return <Tree position={ item }/>})}
            
            <KeyboardControls
                map={ [
                    { name: 'forward', keys: [ 'ArrowUp', 'KeyW' ] },
                    { name: 'backward', keys: [ 'ArrowDown', 'KeyS' ] },
                    { name: 'leftward', keys: [ 'ArrowLeft', 'KeyA' ] },
                    { name: 'rightward', keys: [ 'ArrowRight', 'KeyD' ] },
                    { name: 'reset', keys: [ 'KeyR' ] }
                ] }
            >
                
                    <Car />
            </KeyboardControls>
            
        </Physics>
    </>
}